export const TOPBAR_HEIGHT = 56;
export const SIDEBAR_WIDTH = 280;
export const SIDEBAR_COLLAPSED_WIDTH = 80;

/** The nav rail's width for a given collapse state. */
export const getSidebarInset = (collapsed: boolean) => (collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH);

/**
 * Breakpoints as measured against the *page content* area, i.e. the viewport
 * minus whatever horizontal space the nav rail takes up. The MUI theme shifts
 * these up by the current sidebar inset (see `createHwyTheme`), so a page at an
 * 800px viewport with the rail expanded (280px) sees 520px of content and
 * correctly reports as `xs`.
 */
export const BREAKPOINT_VALUES = {
    xs: 0,
    sm: 672,
    md: 1056,
    lg: 1312,
    xl: 1584,
};

/**
 * Shifts every breakpoint up by `sidebarInset` so a breakpoint describes the
 * width of the content area rather than the whole window. `xs` stays pinned at 0
 * — it's the floor, not a threshold.
 */
export const offsetBreakpointValues = (sidebarInset: number) =>
    Object.fromEntries(
        Object.entries(BREAKPOINT_VALUES).map(([key, value]) => [
            key,
            value === 0 ? 0 : value + sidebarInset,
        ]),
    ) as typeof BREAKPOINT_VALUES;

export const MEETING_HEIGHT = 580;
export const MEETING_WIDTH = 620;

export const PAGE_CONTAINER = "page";
